import { SortIcon } from '@unistocks/components/table/sort-icon';
import { getLocation, Table } from '@unistocks/components/table/table';
import {
  PortfolioActions,
  selectTransactionFilter
} from '@unistocks/features/portfolios/store/portfolio.slice';
import { TransactionFilter } from '@unistocks/features/portfolios/transactions/transaction-filter';
import { SortOrder } from '@unistocks/proxy/axios-client';
import { useAppDispatch, useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { t } from '@unistocks/shared/localization/index.ts';
import React from 'react';

export type TransactionListHeaderProps = {
  portfolioId: string;
  isLoading?: boolean;
};

export const TransactionListHeader: React.FC<TransactionListHeaderProps> = ({
  portfolioId,
  isLoading
}) => {
  const dispatch = useAppDispatch();
  const filter = useAppSelector(selectTransactionFilter(portfolioId));

  const columns: { prop: TransactionFilter['sorting']['prop']; label: string }[] = [
    { prop: 'date', label: t('::Date') },
    { prop: 'type', label: t('::Type') },
    { prop: 'amount', label: t('::Transaction:Amount') }
  ];

  const handleSorting = (prop: TransactionFilter['sorting']['prop']) => {
    dispatch(
      PortfolioActions.setTransactionFilter({
        id: portfolioId,
        filter: {
          ...filter,
          sorting: {
            prop,
            direction:
              filter.sorting.prop === prop
                ? filter.sorting.direction === SortOrder.Ascending
                  ? SortOrder.Descending
                  : SortOrder.Ascending
                : SortOrder.Ascending
          }
        }
      })
    );
  };

  return (
    <Table.Head>
      <Table.Row justifyContent="space-between" alignItems="center">
        {columns.map(({ prop, label }, i) => (
          <Table.HeaderCell
            key={prop}
            sortable
            gap={'$2'}
            cellLocation={getLocation(i, columns)}
            alignHeaderCells={{
              x: getLocation(i, columns) === 'last' ? 'end' : 'start',
              y: 'center'
            }}
            disabled={isLoading}
            onPress={() => handleSorting(prop)}
          >
            <Table.HeaderCellText>{label}</Table.HeaderCellText>
            <SortIcon prop={prop} sorting={filter.sorting} isLoading={isLoading} />
          </Table.HeaderCell>
        ))}
      </Table.Row>
    </Table.Head>
  );
};

TransactionListHeader.displayName = 'TransactionListHeader';
